import * as tool from '../api/common';
//import const_data from '../api/const_data';
import wx from 'weixin-js-sdk';

import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource';

Vue.use(Vuex)
Vue.use(VueResource);


const mutations = {

  //分站标识
  set_fz_tag : function(state, tag) {
    state.fz_tag = tag;
    sessionStorage.setItem('fz_tag', tag);
 },

  set_objVal: function (state, obj) {
    for(var key in obj){
      //console.log(key + '---' + obj[key]);
      state.objVal[key] = obj[key];
    }
 },

  //服务请求数据的缓存
  set_http_cache: function (state, obj) {
    for(var key in obj){
      // console.log(key + '---' + obj[key]);
      state.http_cache[key] = obj[key];
    }
 },

 set_client_info: function (state, obj) {
  for(var key in obj){
    // console.log(key + '---' + obj[key]);
    state.client[key] = obj[key];
  }
},

 

  set_socket_id: function (state, val) {
    state.socket_id = val;
    state.connect = (val != '' ? true : false);
  },
  set_uid: function (state, val) {
    state.uid = val;
    state.bll_login = (val != '' ? true : false);

    //加载本地缓存
    if (val) {
      tool.load_locData(state);
    }
  },
  set_kill_info: function (state, val) {
    state.kill_info = val;
  },
  set_warn_info: function (state, val) {
    state.warn_info = val;
  },
  set_to_uid: function (state, val) {
    state.to_uid = val;
  },
  set_topic_uid: function (state, val) {
    state.topic_uid = val;
  },
  set_rank_s1s2: function (state, val) {
    state.rank_s1s2 = val;
  },
  set_socket_login: function (state, val) {
    state.socket_login = val;
  },
  set_openid: function (state, val) {
    state.openid = val;
  },
  set_wxInfo: function (state, val) {
    state.wxInfo = val;
  },

  set_sysdic: function (state, val) {
    state.sysdic = val;
  },

  set_const_data: function (state, val) {
    state.const_data = val;
  },
  set_msg_count: function (state) {
    state.msg_count += 1;
  },

  //聊天消息（接收到的消息和自己说的话，都在这里边）
  push_message: function (state, chart_msg) {
    var to = '';
    var tag = '';
    var dtm = chart_msg.dtm;
    var msg_dtl = { 'msg_type': chart_msg.type, 'msg_txt': chart_msg.txt };

    if (chart_msg.to) {
      to = chart_msg.to;
      tag = 'self';
    }
    else {
      to = chart_msg.from;
      tag = 'to';
    }

    var const_data = state.const_data;
    //1. 消息详情完整化(礼物消息、加好友消息)
    msg_dtl = tool.complate_msg(state, const_data, msg_dtl, tag);
    //2. 敏感词汇过滤
    if (tag == 'to' && msg_dtl.msg_type == 'text') {
      msg_dtl = tool.deal_msg_txt(msg_dtl);
    }
    //3. 消息格式化
    var msg_item = tool.formate_msg(to, msg_dtl, tag, dtm);
    //4. 加入到message中
    var idx = tool.hasKey(state.message, to, 'to')
    if (idx < 0) {
      state.message.push({ 'to': to, 'txts': [] });
      idx = state.message.length - 1;
    }

    state.message[idx]['txts'].push(msg_item);
    //本地缓存
    localStorage.setItem('loc_message', JSON.stringify(state.message));
  },

  set_message_item_redtag: function (state, uid) {
    var idx = tool.hasKey(state.message, uid, 'to')
    if (idx >= 0) {
      //优化执行效率(倒序计算)
      var msgs = state.message[idx]['txts'];
      for (var i in msgs) {
        msgs[i].read_tag = true;
      }
      //本地缓存
      localStorage.setItem('loc_message', JSON.stringify(state.message));
    }
  },

  clear_message:function (state, val) {
    state.message = [];
    localStorage.setItem('loc_message', JSON.stringify(state.message));
  },

  remove_message:function (state, uid) {
    var idx = tool.hasKey(state.message, uid, 'to')
    if (idx >= 0) {
      state.message.splice(idx, 1);
      //本地缓存
      localStorage.setItem('loc_message', JSON.stringify(state.message));
    }
  },

  //设置用户信息
  push_userinfo: function (state, data) {
    //检查dat中photo数据
    if(data){
      var photo = data.photo;
      if (photo.indexOf(state.url) == -1) {
        data.photo = state.url + '/photo/' + photo;
      }

      //增加时间戳
      data.time = (new Date()).Format("yyyy/MM/dd hh:mm:ss");
  
      var uid = data.uid;
      var idx = tool.hasKey(state.userinfo, uid, 'uid')
      if (idx < 0) {
        state.userinfo.push(data);
      }
      else {
        state.userinfo[idx] = data;
      }
      //本地缓存
      localStorage.setItem('loc_userinfo', JSON.stringify(state.userinfo));
    }
  },

  set_index_tag: function (state, tag) {
    state.index_tag = tag;
  },
  set_online_count: function (state, val) {
    state.online_count = val;
  },

  //消息页面，最近在线通知
  push_least_online: function (state, arry) {
    state.least_online = arry;
  },

  //拉黑、投诉
  push_my_complain: function (state, data) {
    var uid = data.uid;
    var idx = tool.hasKey(state.my_complain, uid, 'uid')
    if (idx < 0) {
      state.my_complain.push(data);
    }
  },

  set_my_complain: function (state, val) {
    state.my_complain = val;
  },

  push_complain_my: function (state, data) {
    var uid = data.uid;
    var idx = tool.hasKey(state.complain_my, uid, 'uid')
    if (idx < 0) {
      state.complain_my.push(data);
    }
  },

  push_my_friend: function (state, data) {
    if (data) {
      state.my_friend = data;
    }
  },

  /* -------------微信调用相关封装------------------- */
  WxConfig(state, data) {
    var client = state.client;
    if (!client.is_wx) {
         console.log('非微信环境,不做WxConfig...');         
         return false;  
    }
    
    //苹果兼容性处理
    var url = data.url;
    if(client.is_ios){
      url = window.entryUrl;
    }

    //检查是否配置过
    var wx_config = state.objVal.wx_config;
    if(wx_config.includes(url)){
      return true;
    }
    
    this.commit('get', {
      url: '/Common/WxConfig/?data=' + url,
      success: function (json) {
        wx.config({
          debug: false,
          appId: '' + json.appId + '',
          timestamp: json.timeStamp,         // 必填，生成签名的时间戳
          nonceStr: '' + json.nonceStr + '', // 必填，生成签名的随机串
          signature: '' + json.paySign + '', // 必填，签名，见附录1
          jsApiList: ['chooseWXPay', 'updateAppMessageShareData','updateTimelineShareData', 'openLocation', 'startRecord', 'stopRecord', 'playVoice', 'uploadVoice', 'downloadVoice', 'translateVoice', 'onVoicePlayEnd', 'stopVoice', 'pauseVoice'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        //优化微信配置缓存处理
        state.objVal.wx_config.push(url);
      },
      error: function (err) {

      }
    });
  },

  WxPay(state, data) {
    this.commit('post', {
      url: '/Common/WxPayFor',
      data: { 'data': data.strSend },
      success: function (json) {
        wx.ready(function () {
          wx.chooseWXPay({
            timestamp: json.timeStamp,           // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: '' + json.nonceStr + '',   // 支付签名随机串，不长于 32 位
            package: '' + json.package + '',     // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
            signType: '' + json.signType + '',   // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: '' + json.paySign + '',     // 支付签名
            success: function (res) {
              data.success(res);
            },
            cancel: function (res) {
              data.cancel(res);
            },
            fail: function (res) {
              data.fail(res);
            }
          });
        });
      },
      error: function (err) {
        console.log(err);
      }
    });
  },

  wxShare(state, data){
    wx.ready(function () {
      wx.updateAppMessageShareData(data);
      wx.updateTimelineShareData(data);
    });
  },

  //开始录音
  wxStartRecord(state, data) {
    wx.startRecord();
  },
  //停止录音
  wxStopRecord(state, data) {
    wx.stopRecord({
      success: function (res) {
        data.suc(res);
      },
      fail: function (err) {}
    });
  },
  //播放录音
  wxPlayVoice(state, data) {
    wx.playVoice({
      localId: data // 需要播放的音频的本地ID，由stopRecord接口获得
    });
  },
   //暂停播放
   wxPauseVoice(state, data) {
    wx.pauseVoice({
      localId: data // 需要暂停的音频的本地ID，由stopRecord接口获得
    })
  },
  //停止播放
  wxStopVoice(state, data) {
    wx.stopVoice({
      localId: data // 需要停止的音频的本地ID，由stopRecord接口获得
    });
  },
  
  
  //上传到服务器
  wxUploadVoice(state, data) {
    wx.uploadVoice({
      localId: data.localId, // 需要上传的音频的本地ID，由stopRecord接口获得
      isShowProgressTips: 0, // 默认为1，显示进度提示
      success: function (res) {
        var serverId = res.serverId; // 返回音频的服务器端ID
        data.suc(serverId);
      }
    });
  },
  //下载到本地
  wxDownloadVoice(state, data) {
    wx.downloadVoice({
      serverId: data.serverId, // 需要下载的音频的服务器端ID，由uploadVoice接口获得
      isShowProgressTips: 0, // 默认为1，显示进度提示
      success: function (res) {
        var localId = res.localId; // 返回音频的本地ID
        data.suc(localId);
      }
    });
  },

  //监听语音播放结束
  wxOnVoicePlayEnd(state, data) {
    wx.onVoicePlayEnd({
      success: function (res) {
        var localId = res.localId; // 返回音频的本地ID
        data.suc(localId);
      }
    });
  },
 
  //识别语音信息
  wxTranslateVoice(state, data) {
    wx.translateVoice({
      localId: data.localId, // 需要识别的音频的本地Id，由录音相关接口获得
      isShowProgressTips: 0, // 默认为1，显示进度提示
      success: function (res) {
        data.suc(res.translateResult);
        alert(JSON.stringify(res.translateResult));
      }
    });
  },

  /* -------------http封装------------------- */
  setUrl(state, res) {
    state.url = res
  },
  get(state, data) {
    Vue.http.options.xhr = { withCredentials: true }
    Vue.http({
      method: 'GET',
      url: state.url + data.url,
      emulateJSON: true
    })
      .then(function (success) {
        data.success(success.body);
      }, function (error) {
        data.error(error.body);
      })
  },
  post(state, data) {
    Vue.http({
      method: 'POST',
      url: state.url + data.url,
      params: data.data,
      emulateJSON: true
    }).then(function (success) {
      data.success(success.body);
    }, function (error) {
      data.error(error.body);
    })
  },
  post2(state, data) {
    Vue.http.post(state.url + data.url,
      data.data,
      {
        'headers': {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        data.success(res.body);
      }, function (res) {
        data.error(res.body);
      });
  },
  upload(state, data) {
    Vue.http.post(state.url + '/Common/UpLoadImage',
      data.data,
      {
        'headers': {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        data.success(res.body);
      }, function (res) {
        data.error(res.body);
      });
  },
  delete(state, data) {
    Vue.http({
      method: 'DELETE',
      url: state.url + data.url,
      params: data.data,
      emulateJSON: true
    }).then(function (success) {
      data.success(success.body);
    }, function (error) {
      data.error(error.body);
    })
  },
  put(state, data) {
    Vue.http({
      method: 'PUT',
      url: state.url + data.url,
      params: data.data,
      emulateJSON: true
    }).then(function (success) {
      data.success(success.body);
    }, function (error) {
      data.error(error.body);
    })
  }

};

export default mutations;